// 获取svip的版本josn
import axios from '@/static/js/request'
import { getformData } from '@/static/js/zjs'
import { ossUrl } from '../static/js/oss'

interface GetEditionParams {
  openid: string
}
interface EditionValue {
  courseId: number
  courseName: string
  editionId: number
  editionName: string
  grade?: null
  id?: number
  openid?: string
}
type keys = 'shuxue' | 'yuwen' | 'yingyu'
export function getEdition({ openid }: GetEditionParams): Promise<
  {
    all: EditionValue[],
    ysy: { [key in keys]: EditionValue | null }
  }
> {

  return axios.get<EditionValue[]>(`/cms/svipResources/getedition?openid=${openid}`).then((res) => {
    const subjects: keys[] = ['shuxue', 'yuwen', 'yingyu']
    const ret: {
      [key in keys]: EditionValue | null
    } = {
      yuwen: null,
      shuxue: null,
      yingyu: null,
    }

    res.data.forEach((item) => {
      const courseId = item.courseId as 1 | 2 | 3
      const key = subjects[courseId - 1]
      if (subjects.includes(key)) {
        ret[key] = item
      }
    })

    return {
      all: res.data,
      ysy: ret
    }
  })
}


export function saveEdition({ openid }: GetEditionParams, list: EditionValue[]) {
  var json: {
    [key: string]: EditionValue
  } = {}
  list.forEach((item, index) => {
    json[`course${index}`] = item
  });

  return axios.post(
    '/cms/svipResources/saveedition',
    getformData({
      openid,
      json: JSON.stringify(json)
    })
  )
}



interface VersionItem {
  name: string
  version: number
}
export interface CourseItem {
  course: number
  name: string
  versions: VersionItem[]
}
interface DataVersionListFromJSON {
  grade: number
  courses: CourseItem[]
}

const historyVersionListFromJSON: DataVersionListFromJSON[] = []
export function getVersionListFromJSON(appid: string, gradeNumber: string | number): Promise<DataVersionListFromJSON> {
  const history = historyVersionListFromJSON[Number(gradeNumber)]
  if (history) {
    return Promise.resolve().then(() => history)
  }
  const url = ossUrl(`/userPref/${appid}/grade${gradeNumber}_course_version.json`)
  return axios.get<DataVersionListFromJSON>(url).then(res => {
    historyVersionListFromJSON[Number(gradeNumber)] = res.data
    return res.data
  })
}

interface DicItemBookVersion {
  chName: string
  // children: null
  enName: string
  id: string
  parentId: string
  sort: number
  value: string
}
interface CompletionCourseItemDest { course: number, versions: number[] }
export function completionCourseItem(dest: CompletionCourseItemDest, bookVersionDictionary: DicItemBookVersion[], dicSettingCourses: CourseItem[]): CourseItem {
  const cour = dicSettingCourses.find(c => c.course === dest.course)
  const versions = dest.versions.map(versionId => {
    const item = bookVersionDictionary.find(({ value }) => Number(value) === versionId)
    return {
      name: item?.chName || '',
      version: versionId
    }
  })
  return {
    course: dest.course,
    name: cour?.name || '',
    versions
  }
}

// 版本id列表和用户设置的版本的交集版本
export function filterEditionValue(ev: EditionValue[], dest: CompletionCourseItemDest): VersionItem[] {
  return ev.filter(({ courseId, editionId }) => {
    return courseId === dest.course && (dest.versions.includes(editionId) || dest.versions.includes(0))
  }).map(({ editionId, editionName }) => {
    return {
      version: editionId,
      name: editionName
    }
  })
}

export function findVersion(src: CourseItem[], callback: (args: {
  course: number
  version: number
  courseName: string
  versionName: string
}) => boolean): VersionItem | void {
  let version: VersionItem | void = undefined
  src.find((item) => {
    version = item.versions.find((v) => {
      return callback({
        course: item.course,
        courseName: item.name,
        version: v.version,
        versionName: v.name
      })
    })
    return version
  })
  return version
}


